import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'

import { login } from '../actions/profile'
import Modal from '../components/Modal'
import InputText from '../components/InputText'
import { triggerResetPassword } from '../actions/market'

const styles = {
  root: {
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // background: `url(${backgroundSrc})`,
  },
  content: {
    width: 600,
    maxWidth: '100%',
  },
  title: {
    top: 30,
    position: 'fixed',
  },
  textField: {
    marginTop: 10,
  },
  modal: {
    alignItems: 'center',
  },
  passwordSection: {
    marginTop: 30,
  },
  forgotPasswordContainer: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}

const Login = ({
  classes,
  isLoading,
  login: loginAction,
  triggerResetPassword: triggerResetPasswordAction,
}) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showForgotPassword, setShowForgotPassword] = useState(false)

  const createChangeHandler = fn => e => fn(e.target.value)

  const toggleShowForgotPassword = () => setShowForgotPassword(!showForgotPassword)
  const handleLogin = () => loginAction(email, password)

  const handleForgotPassword = () => {
    triggerResetPasswordAction(email)
    toggleShowForgotPassword()
  }

  return (
    <div className={classes.root}>
      <Modal
        open
        title={showForgotPassword ? 'Mot de passe oublié' : 'Connexion'}
        isLoading={isLoading}
        submitLabel={showForgotPassword ? 'Envoyer l\'email de réinitialisation' : 'Connexion'}
        onSubmit={showForgotPassword ? handleForgotPassword : handleLogin}
        containerClassName={classes.modal}
        cancelLabel={showForgotPassword ? 'Retour' : ''}
        onCancel={showForgotPassword ? toggleShowForgotPassword : null}
      >
        <div className={classes.content}>
          {/* <img alt="Elytiz" src={titleSrc} className={classes.title} /> */}

          <Typography>E-mail</Typography>

          <InputText
            fullWidth
            type="email"
            name="E-mail"
            value={email}
            className={classes.textField}
            onChange={createChangeHandler(setEmail)}
          />

          {!showForgotPassword && (
            <>
              <Typography className={classes.passwordSection}>Mot de passe</Typography>
              <InputText
                fullWidth
                type="password"
                name="Mot de passe"
                value={password}
                onPressEnter={handleLogin}
                className={classes.textField}
                onChange={createChangeHandler(setPassword)}
              />

              <div className={classes.forgotPasswordContainer}>
                <Button
                  onClick={toggleShowForgotPassword}
                  color="primary"
                  variant="text"
                >
                  Mot de passe oublié ?
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  )
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  triggerResetPassword: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
})

export default connect(mapStateToProps, {
  login,
  triggerResetPassword,
})(withStyles(styles)(Login))
